import { render } from "./TopHeader.vue?vue&type=template&id=5f3987ba&scoped=true"
import script from "./TopHeader.vue?vue&type=script&lang=js"
export * from "./TopHeader.vue?vue&type=script&lang=js"

import "./TopHeader.vue?vue&type=style&index=0&id=5f3987ba&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5f3987ba"

export default script